import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class CountDown {
    constructor(expirationDate, onRender) {
        this.setExpirationDate(expirationDate);
        this.onRender = onRender;
    }

    setExpirationDate( expirationDate ) {
        const currentTime = new Date().getTime();
        this.timeRemaining = expirationDate.getTime() - currentTime;

        this.timeRemaining <= 0 ?
            this.complete() :
            this.start();
    }

    complete() {
        const targetElement = $('.timer__wrapper');
        targetElement.html('');
    }

    getTime() {
        return {
            days: Math.floor(this.timeRemaining / 1000 / 60 / 60 / 24),
            hours: Math.floor(this.timeRemaining / 1000 / 60 / 60) % 24,
            minutes: Math.floor(this.timeRemaining / 1000 / 60) % 60,
            seconds: Math.floor(this.timeRemaining / 1000) % 60,
        };
    }

    update() {
        if ( typeof this.onRender === 'function' ) {
            this.onRender(this.getTime());
        }
    }

    start() {
        this.init();

        const counterUpdater = setInterval( () => {
            this.timeRemaining -= 1000;

            if( this.timeRemaining < 0) {
                this.complete()
                clearInterval(counterUpdater);
            } else {
                this.update();
            }
        }, 1000)
    }

    init() {
        const countUpAnimation = this.countUpAnimation;
        $('.countdown-item').each( function() {
            countUpAnimation($(this))
        })
    }

    countUpAnimation(element) {
        let frame = 0;
        const animationDuration = 1500;
        const frameDuration = 1000 / 60;
        const totalFrames = Math.round(animationDuration / frameDuration );
        const countTo = parseInt( element.html() );
        const easeOutQuad = t => t * ( 2 - t );

        const counterInterval = setInterval( () => {
            frame++

            const progress = easeOutQuad( frame / totalFrames );
            const currentCount = Math.round( countTo * progress );

            if ( element.html() !== currentCount ) {
                element.html( currentCount );
            }

            if( frame === totalFrames ) {
                clearInterval( counterInterval );
            }
        }, frameDuration)
    }
}

const render = (countdown) => {
    var dagen = 'dagen';
    var uur = 'uur';
    var minuten = 'minuten';
    var seconden = 'seconden';
    if($('.check-current-lang-en').length != 0){
        dagen = 'days';
        uur = 'hours';
        minuten = 'minutes';
        seconden = 'seconds';
    }
    const targetElement = $('.timer__wrapper__time');
    targetElement.html(`
    <div class="timer__wrapper__time__item">
            <div class="countdown-item countdown-item--days">
                ${countdown.days}
            </div>
            ${dagen}
        </div>
        <div class="timer__wrapper__time__item">
            <div class="countdown-item countdown-item--hour">
                ${countdown.hours}
            </div>
            ${uur}
        </div>
        <div class="timer__wrapper__time__item">
            <div class="countdown-item countdown-item--minutes">
                ${countdown.minutes}
            </div>
            ${minuten}
        </div>
        <div class="timer__wrapper__time__item">
            <div class="countdown-item countdown-item--seconds">
                ${countdown.seconds}
            </div>
            ${seconden}
        </div>
    `);
}

const getSelectedTimer = (target) => {
    if( target.length != 0 ) {
        const selectedTime = target.data('date-target');
        const transformedString = selectedTime.replace(/(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/, "$1-$2-$3T$4:$5:$6.000Z");
        const formattedTime = Date.parse(transformedString);
        const dateObject = new Date(formattedTime);

        return dateObject;
    }

}

const selectedStartTime = getSelectedTimer($('.timer__wrapper__time'));

function countdownTimer() {
    new CountDown(
        selectedStartTime,
        render,
    );
}

const timeline2 = gsap.timeline({
    scrollTrigger: {
        trigger: '.module--timer',
        pin: false,
        scrub: 0.4,
        start: 'bottom bottom',
        onEnter: countdownTimer,
        end: "+=50%",
    },
});

timeline2
    .from('.timer__wrapper__time', {
        opacity: 0,
        x: '100',
    }, '<');
